import dayjs from 'dayjs';
import 'dayjs/locale/en';
import Weekday from 'dayjs/plugin/weekday';

dayjs.extend(Weekday);

const displayMonday = dayjs().locale('en').weekday(1).format('M.D');
const displayMonth = dayjs().date() < 27 ? dayjs().format('MMMM') : dayjs().add(1, 'month').format('MMMM');

export const navigation = [
    {
        name: 'Tarot',
        link: '/tarot',
        submenu: [
            {
                name: 'Tarot Readings',
                link: '/readings-reports/tarot',
                links: [
                    {
                        name: 'FREE 3-Card Tarot Reading',
                        link: '/readings-reports/tarot-readings/free',
                        logged_in: {
                            name: 'Daily Tarot Reading',
                            link: '/readings-reports/tarot-readings/daily-reflection',
                        },
                    },
                    {
                        name: 'FREE Love Tarot Reading',
                        link: '/readings-reports/tarot-readings/free/love',
                        logged_in: {
                            name: 'Yes or No Tarot Reading',
                            link: '/readings-reports/tarot-readings/yes-no',
                        },
                    },
                    {
                        name: 'Yes or No Tarot Reading',
                        link: '/readings-reports/tarot-readings/yes-no',
                        logged_in: {
                            name: 'Soulmate Tarot Reading',
                            link: '/readings-reports/tarot-readings/soulmate',
                        },
                    },
                    {
                        name: 'Daily Tarot Reading',
                        link: '/readings-reports/tarot-readings/daily-reflection',
                        logged_in: {
                            name: 'Two Hearts Tarot',
                            link: '/readings-reports/tarot-readings/two-hearts',
                        },
                    },
                    {
                        name: 'All Tarot Readings',
                        link: '/readings-reports/tarot',
                    },
                ],
            },
            {
                name: 'Tarot 101',
                link: '/tarot',
                links: [
                    {
                        name: 'FREE Weekly Tarot Reading',
                        link: '/tarot/weekly-tarot-card-reading',
                    },
                    {
                        name: 'Explore Tarot Cards',
                        link: '/tarot/cards',
                    },
                    {
                        name: 'Explore Tarot Decks',
                        link: '/tarot/decks',
                    },
                    {
                        name: 'Explore Tarot Readings',
                        link: '/readings-reports/tarot',
                    },
                    {
                        name: 'TAROT CARD MEANINGS',
                        link: '/tarot/cards/the-fool',
                    },
                ],
            },
        ],
        articles: {
            name: 'View Our Tarot Articles',
            tag:'tarot',
            url: '/news/tarot',
        },
    },
    {
        name: 'Readings',
        link: '/readings-reports',
        submenu: [
            {
                name: 'Ask the Tarot',
                link: '/readings-reports/tarot',
                logged_in: {
                    name: 'Ask the Tarot',
                    link: '/readings-reports/tarot',
                },
                links: [
                    {
                        name: 'FREE 3-Card Tarot Reading',
                        link: '/readings-reports/tarot-readings/free',
                        logged_in: {
                            name: 'Relationship Analysis',
                            link: '/readings-reports/tarot-readings/analysis/relationship',
                        },
                    },
                    {
                        name: 'FREE Love Tarot Reading',
                        link: '/readings-reports/tarot-readings/free/love',
                        logged_in: {
                            name: 'Will It Be Yes or No?',
                            link: '/readings-reports/tarot-readings/yes-no',
                        },
                    },
                    {
                        name: 'FREE Daily Tarot Reading',
                        link: '/readings-reports/tarot-readings/daily-reflection',
                        logged_in: {
                            name: 'What Does My Future Hold?',
                            link: '/readings-reports/tarot-readings/celtic-cross',
                        },
                    },
                    {
                        name: 'Yes or No Tarot Reading',
                        link: '/readings-reports/tarot-readings/yes-no',
                        logged_in: {
                            name: 'When Will I Find Love?',
                            link: '/readings-reports/tarot-readings/analysis/love-quest',
                        },
                    },
                    {
                        name: 'View All Tarot Readings',
                        link: '/readings-reports/tarot',
                    },
                ],
            },
            {
                name: 'More Readings',
                link: '/readings-reports',
                links: [
                    {
                        name: 'FREE Birth Chart Reading',
                        link: '/readings-reports/astrology-reports/essential-birth-chart/free',
                        logged_in: {
                            name: 'Birth Chart Reading',
                            link: '/readings-reports/astrology-reports/essential-birth-chart',
                        },
                    },
                    {
                        name: 'FREE Zodiac Compatibility',
                        link: '/astrology/compatibility/love',
                        logged_in: {
                            name: 'Astrology Compatibility Report',
                            link: '/readings-reports/astrology-reports/astrology-compatibility',
                        },
                    },
                    {
                        name: 'FREE I Ching Reading',
                        link: '/readings-reports/i-ching/free',
                        logged_in: {
                            name: 'Horoscope Tarot Reading',
                            link: '/readings-reports/tarot-readings/horoscope-tarot',
                        },
                    },
                    {
                        name: 'FREE Chinese Compatibility',
                        link: '/astrology/compatibility/chinese',
                        logged_in: {
                            name: 'I Ching Reading',
                            link: '/readings-reports/i-ching/free',
                        },
                    },
                    {
                        name: 'View All Free Readings',
                        link: '/readings-reports/free',
                        logged_in: {
                            name: 'View All Readings',
                            link: '/readings-reports',
                        },
                    },
                ],
            },
        ],
        articles: {
            name: 'Explore Our Readings & Reports',
            tag:'product',
            url: '/readings-reports',
        },
    },
    {
        name: 'Horoscopes',
        link: '/horoscopes',
        submenu: [
            {
                name: 'General Horoscopes',
                link: '/horoscopes',
                links: [
                    {
                        name: 'Daily Horoscope',
                        link: '/daily-horoscope',
                    },
                    {
                        name: `${displayMonth} Horoscope`,
                        link: '/horoscopes/monthly',
                    },
                    {
                        name: '2021 Horoscope',
                        link: '/horoscopes/2021',
                    },
                    {
                        name: 'Personalize Your Horoscope',
                        link: '/readings-reports/subscription/vip-membership',
                    },
                    {
                        name: 'View All Horoscopes',
                        link: '/horoscopes',
                    },
                ],
            },
            {
                name: 'Love Horoscopes',
                link: '/love-and-compatibility',
                links: [
                    {
                        name: 'Daily Love Horoscope',
                        link: '/daily-love-horoscope',
                    },
                    {
                        name: `Week of ${displayMonday} Love Horoscope`,
                        link: '/astrology/weekly-love-horoscopes',
                    },
                    {
                        name: '2021 Love Horoscope',
                        link: '/horoscopes/2021-love',
                    },
                    {
                        name: 'FREE Love Predictions',
                        link: '/readings-reports/tarot-readings/free/love',
                        logged_in: {
                            name: 'Love Advice for Your Situation',
                            link: '/readings-reports/tarot-readings/celtic-cross/love',
                        },
                    },
                    {
                        name: 'More Love Insight',
                        link: '/love-and-compatibility',
                    },
                ],
            },
        ],
        articles: {
            name: 'Featured Horoscopes',
            tag: 'horoscopes',
            url: '/news/horoscopes',
        },
    },
    {
        name: 'Love',
        link: '/love-and-compatibility',
        submenu: [
            {
                name: 'Love Readings',
                link: '/readings-reports/love-readings',
                links: [
                    {
                        name: 'FREE Love Tarot Reading',
                        link: '/readings-reports/tarot-readings/free/love',
                        logged_in: {
                            name: 'Where Is Your Soulmate?',
                            link: '/readings-reports/tarot-readings/soulmate',
                        },
                    },
                    {
                        name: 'FREE Love Calculator',
                        link: '/astrology/compatibility/love',
                        logged_in: {
                            name: 'Who Wants You Back?',
                            link: '/readings-reports/tarot-readings/reconciliation',
                        },
                    },
                    {
                        name: 'FREE Astrology Compatibility',
                        link: '/readings-reports/astrology-reports/astrology-compatibility/free',
                        logged_in: {
                            name: 'How Do They Feel About You?',
                            link: '/readings-reports/tarot-readings/two-hearts',
                        },
                    },
                    {
                        name: 'What Is Your Love Outcome?',
                        link: '/readings-reports/tarot-readings/bottom-line/love',
                        logged_in: {
                            name: 'Where Is This Relationship Going?',
                            link: '/readings-reports/tarot-readings/potentials/relationship',
                        },
                    },
                    {
                        name: 'All Love Readings',
                        link: '/readings-reports/love-readings',
                    },
                ],
            },
            {
                name: 'Love Horoscopes',
                link: '/daily-love-horoscope',
                links: [
                    {
                        name: 'Daily Love Horoscope',
                        link: '/daily-love-horoscope',
                    },
                    {
                        name: 'Weekly Love Horoscope',
                        link: '/astrology/weekly-love-horoscopes',
                    },
                    {
                        name: 'Monthly Love Horoscope',
                        link: '/horoscopes/monthly',
                    },
                    {
                        name: '2021 Love Horoscope',
                        link: '/horoscopes/2021-love',
                    },
                    {
                        name: 'More Love Insight',
                        link: '/love-and-compatibility',
                    },
                ],
            },
        ],
        articles: {
            name: 'Trending Love Articles',
            tag: 'relationships',
            url: '/news/love',
        },
    },
    {
        name: 'Astrology',
        link: '/astrology',
        submenu: [
            {
                name: 'Astrology Readings',
                link: '/readings-reports/astrology',
                links: [
                    {
                        name: 'FREE Birth Chart Reading',
                        link: '/readings-reports/astrology-reports/essential-birth-chart/free',
                        logged_in: {
                            name: 'Birth Chart Reading',
                            link: '/readings-reports/astrology-reports/essential-birth-chart',
                        },
                    },
                    {
                        name: 'FREE Cosmic Profile',
                        link: '/readings-reports/astrology-reports/cosmic-profile',
                        logged_in: {
                            name: 'Romantic Compatibility Report',
                            link: '/readings-reports/astrology-reports/astrology-compatibility',
                        },
                    },
                    {
                        name: 'Are You Compatible In Love?',
                        link: '/astrology/compatibility/love',
                        logged_in: {
                            name: 'Reveal Your Love Future',
                            link: '/readings-reports/astrology-reports/yearly-forecast/love',
                        },
                    },
                    {
                        name: 'Your Daily Transits',
                        link: '/readings-reports/subscription/vip-membership',
                        logged_in: {
                            name: 'Your Daily Transits',
                            link: '/readings-reports/subscription/vip-membership',
                        },
                    },
                    {
                        name: 'All Astrology Reports',
                        link: '/readings-reports/astrology',
                    },
                ],
            },
            {
                name: 'All About Astrology',
                link: '/astrology',
                links: [
                    {
                        name: 'Benefits of a Birth Chart',
                        link: '/astrology/birth-chart-benefits',
                    },
                    {
                        name: 'Zodiac Signs & Their Traits',
                        link: '/astrology/zodiac',
                    },
                    {
                        name: 'Your Moon & Rising Signs',
                        link: '/astrology/sun-moon-rising-sign',
                        logged_in: {
                            name: 'Your Rising Sign',
                            link: '/astrology/traits-of-rising-signs',
                        },
                    },
                    {
                        name: 'The 12 Houses of Astrology',
                        link: '/astrology/12-zodiac-houses',
                    },
                    {
                        name: 'Current Planetary Positions',
                        link: '/astrology',
                    },
                ],
            },
        ],
        articles: {
            name: 'Popular Astrology Articles',
            tag: 'astrology',
            url: '/news/astrology',
        },
    },
    {
        name: 'More Insight',
        link: '/eastern-wisdom',
        submenu: [
            {
                name: 'About the I Ching',
                link: '/news/i-ching',
                links: [
                    {
                        name: 'FREE I Ching Reading',
                        link: '/readings-reports/i-ching/free',
                    },
                    {
                        name: 'FREE Chinese Compatibility',
                        link: '/readings-reports/i-ching/free/love',
                    },
                    {
                        name: 'Explore I Ching Hexagrams',
                        link: '/i-ching/hexagrams',
                    },
                    {
                        name: '2021 Chinese Horoscopes',
                        link: '/horoscopes/chinese-2021',
                    },
                    {
                        name: 'MORE EASTERN INSIGHT',
                        link: '/eastern-wisdom',
                    },
                ],
            },
            {
                name: 'More Insight',
                link: '/news/all',
                links: [
                    {
                        name: 'FREE Tarot.com Membership',
                        link: '/member/benefits',
                        logged_in: {
                            name: 'Daily I Ching Hexagrams',
                            link: '/daily-hexagram',
                        },
                    },
                    {
                        name: 'FREE Cosmic Personality Reading',
                        link: '/readings-reports/astrology-reports/cosmic-profile',
                    },
                    {
                        name: 'Save 50% on Readings',
                        link: '/articles/karma-coins',
                    },
                    {
                        name: 'Explore Numerology',
                        link: '/numerology',
                    },
                    {
                        name: 'Learn More Now',
                        link: '/news/all',
                    },
                ],
            },
        ],
        articles: {
            name: 'Our Latest Articles',
            tag: 'readings',
            url: '/news/readings',
        },
    },
];
